import React from 'react';
import { importComponent, useServerData } from '@xingternal/hops';

import { ZenView } from '@xingternal/platform-layout-zen';
import { FeatureSwitch } from '@xingternal/feature-switch';

import LoggedInApp from './components/LoggedInApp';
import LoggedOutApp from './components/LoggedOutApp';
import { ErrorBoundary } from '@xingternal/pages-page-error';

const TopBar = importComponent(() => import('./components/TopBar'));

export const SocialLayout = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
);

type LayoutProps = {
  children: React.ReactNode;
  isZenView?: boolean;
  isMainPage?: boolean;
  isWebview?: boolean;
};

const Layout = ({
  children,
  isZenView,
  isMainPage,
  isWebview,
}: LayoutProps) => {
  const { authenticated } = useServerData();
  if (isWebview) {
    return <>{children}</>;
  }
  if (isZenView) {
    return (
      <ZenView>
        <ErrorBoundary type={500}>{children}</ErrorBoundary>
      </ZenView>
    );
  }
  if (authenticated) {
    return (
      <LoggedInApp>
        <FeatureSwitch flags={['armstrong_v1']}>
          <TopBar isMainPage={isMainPage} />
        </FeatureSwitch>
        <ErrorBoundary type={500}>{children}</ErrorBoundary>
      </LoggedInApp>
    );
  }
  return (
    <LoggedOutApp>
      <ErrorBoundary type={500}>
        <TopBar isMainPage={isMainPage} />
        {children}
      </ErrorBoundary>
    </LoggedOutApp>
  );
};

export default Layout;
